import React, {useState} from 'react';
import {GuardedRoute} from 'react-router-guards';
import Section from '../../../../components/Section/Section';

const GeneralIndicators = ({match}) => {
  const [templateData] = useState([
    {
      category: 'Indicadores gerais',
      options: [
        {
          group: ' ',
          options: [
            {
              title: 'Indicadores de Gestão Técnica Econômica',
              //   url: `${match.url}/tipo/receitas`,
            },
            {
              title: 'Perfil técnico',
              //   url: `${match.url}/tipo/despesas`,
            },
          ],
        },
      ],
    },
  ]);
  return (
    <div className="zoodata">
      <GuardedRoute exact path={match.url} meta={{moduleName: 'Indicadores gerais'}} render={() => <Section templateData={templateData} />} />
    </div>
  );
};
export default GeneralIndicators;
